import { render, staticRenderFns } from "./plan-info.vue?vue&type=template&id=1f6c2170&scoped=true&"
import script from "./plan-info.vue?vue&type=script&lang=js&"
export * from "./plan-info.vue?vue&type=script&lang=js&"
import style0 from "./plan-info.vue?vue&type=style&index=0&id=1f6c2170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c2170",
  null
  
)

export default component.exports